import type { Dispatch, SetStateAction } from 'react';

import { Dialog } from '@/components/Dialog';

import PostGenerationBody from './PostGenerationBody';
import PreGenerationBody from './PreGenerationBody';
import useGenerationBody from './useGenerationBody';

const KeyDialog = ({
  open,
  setOpen
}: {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const {
    generated,
    handleClose,
    handleChange,
    apiKeyName,
    onGenerate,
    error,
    loading,
    isError,
    newApiKey,
    exportToCsv
  } = useGenerationBody();

  const close = () => {
    handleClose(setOpen);
  };

  return (
    <Dialog
      open={open}
      title='Generate new API token'
      onClose={() => {
        setOpen(false);
      }}
    >
      {generated || isError ? (
        <PostGenerationBody
          exportToCsv={exportToCsv}
          handleClose={close}
          isError={isError}
          loading={loading}
          newApiKey={newApiKey}
        />
      ) : (
        <PreGenerationBody
          apiKeyName={apiKeyName}
          error={error}
          handleChange={handleChange}
          handleClose={close}
          loading={loading}
          onGenerate={onGenerate}
        />
      )}
    </Dialog>
  );
};

export default KeyDialog;
